import { Route, Routes } from "react-router-dom";
import AllowedAccess from "../../Layout/AllowedAccess";
import PageNotFound from "../pageNoFound";
import ErrorBoundry from "../../Services/ErrorBoundry";
import { useSelector } from "react-redux";
import TransactionsList from "./TransactionsList";
import FeeCollection from "./FeeCollection";
import UniformTransactions from "./UniformTransactions";
import RegistraionTransactions from "./RegistraionTransactions";
import CreateFeeReceipt from "./CreateFeeReceipt";
import MakePayments from "./MakePayments";

const PaymentsRoutes = () => {
    const { userData } = useSelector((state) => state.user);
    return (
        <Routes>
            <Route
                index
                element={
                    <TransactionsList />
                }
            />
            <Route path="lawazim-collection" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "finance_incharge"]}
                allowedPermissions={["fees_collection","fee_collection_transactions"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<FeeCollection />}
            />} />
            <Route path="lawazim-collection/create-lawazim-receipt" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "finance_incharge"]}
                allowedPermissions={["fees_collection"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<CreateFeeReceipt />}
            />} />
            <Route path="uniform" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "finance_incharge"]}
                allowedPermissions={["uniform_transactions"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<UniformTransactions />}
            />} />
            <Route path="registrations" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "finance_incharge"]}
                allowedPermissions={["registration_transactions"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<RegistraionTransactions />}
            />} />
            <Route path="make-payments" element={
                    <MakePayments />
                } />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}

export default PaymentsRoutes;